import ApiService from "../core/services/api.service";

export default {

  getDepartments() {
    return ApiService.get("/departments");
  },
}
